<template>
  <b-modal
    id="full-doc-modal"
    class="pdf-modal"
    size="xl"
    no-close-on-esc
    no-close-on-backdrop
    no-fade
  >
    <template #modal-header>
      <div id="pdf-viewer-header" class="w-100">
        <h6>
          <span v-if="selectedDoc._source.doc_title">
            {{ displayList(selectedDoc._source.doc_title) }}
          </span>
          <span v-else-if="selectedDoc._source.doc_type">
            {{ displayList(selectedDoc._source.doc_type) }}
          </span>
          <span v-else-if="selectedDoc._source.doc_category">
            {{ displayList(selectedDoc._source.doc_category) }}
          </span>
          <a
            v-if="
              selectedDoc._source.source_url &&
              !(
                selectedDoc._source.doc_type &&
                (typeof selectedDoc._source.doc_type === 'string' ||
                  selectedDoc._source.doc_type instanceof String) &&
                selectedDoc._source.doc_type.search(/archive/i) >= 0
              )
            "
            :href="selectedDoc._source.source_url"
            target="_blank"
          >
            <span
              v-b-tooltip.hover.v-light
              class="ml-2"
              style="cursor: pointer"
              title="Source"
            >
              <font-awesome-icon
                style="color: black"
                :icon="['fas', 'external-link-alt']"
                size="1x"
              />
            </span>
          </a>
          <br />
          <div class="text-muted search-result-sub-title">
            <span
              v-if="
                selectedDoc._source.action_date !== undefined &&
                selectedDoc._source.action_date.length === 10
              "
            >
              {{
                [selectedDoc._source.action_date, 'YYYY-MM-DD']
                  | moment('MMMM D, YYYY')
              }}<span
                v-if="
                  selectedDoc._source.doc_type === 'Guidance Document' &&
                  selectedDoc._source.agency_name === 'FDA'
                "
              >
                (Issue Date)</span
              ><span
                v-else-if="
                  selectedDoc._source.action_date_type &&
                  selectedDoc._source.action_date_type.length > 0
                "
              >
                ({{ selectedDoc._source.action_date_type }})</span
              ><br
            /></span>
            {{ displayList(selectedDoc._source.doc_category) }}
            <span
              v-if="
                selectedDoc._source.doc_category !== undefined &&
                selectedDoc._source.doc_category === 'Guidelines' &&
                selectedDoc._source.doc_type !== undefined &&
                selectedDoc._source.doc_type.length > 0
              "
            >
              - {{ displayList(selectedDoc._source.doc_type) }}</span
            >
            <span
              v-if="
                selectedDoc._source.guidance_status !== undefined &&
                selectedDoc._source.guidance_status.length > 0
              "
            >
              ({{ selectedDoc._source.guidance_status }})</span
            >
            <span
              v-if="
                selectedDoc._source.doc_sub_category &&
                selectedDoc._source.doc_sub_category.length > 0
              "
            >
              - {{ selectedDoc._source.doc_sub_category }}
            </span>
            <b-badge
              v-if="
                selectedDoc._source.doc_type &&
                (typeof selectedDoc._source.doc_type === 'string' ||
                  selectedDoc._source.doc_type instanceof String) &&
                selectedDoc._source.doc_type.search(/archive/i) >= 0
              "
              style="cursor: default"
              variant="danger"
              class="mx-2"
            >
              Archive
            </b-badge>
            <b-badge
              v-if="
                selectedDoc._source.guidance_status &&
                selectedDoc._source.guidance_status.search(/draft/i) >= 0
              "
              style="cursor: default"
              variant="warning"
              class="mx-2"
            >
              Draft
            </b-badge>
            <br />
            {{ selectedDoc._source.agency_name }}
            <span
              v-if="
                selectedDoc._source.agency_division_name &&
                selectedDoc._source.agency_division_name.length > 0
              "
            >
              {{
                Array.isArray(selectedDoc._source.agency_division_name)
                  ? selectedDoc._source.agency_division_name.join(', ')
                  : selectedDoc._source.agency_division_name
              }}
            </span>
          </div>
          <span v-if="selectedDoc._source.products">
            <font-awesome-icon
              :icon="['fas', 'pills']"
              class="mx-2"
              size="1x"
              fixed-width
            />
            {{
              displayList(getUniqueProductNames(selectedDoc._source.products))
            }}
          </span>
        </h6>
        <b-container>
          <b-row>
            <b-col>
              <span
                v-if="annotationSaving"
                class="align-center saving-info-text"
              >
                Saving annotations...
              </span>
              <span
                v-else-if="annotationSaved"
                class="align-center saving-info-text"
              >
                Annotations saved
              </span>
            </b-col>
            <!-- <b-col v-if="filteredEntities && filteredEntities.length > 0">
              Entity Tags
            </b-col> -->
            <b-col>
              <span
                id="download-button"
                class="float-right"
                style="cursor: pointer"
              >
                <b-icon
                  icon="download"
                  style="width: 18px; height: 18px"
                ></b-icon>
              </span>
              <template v-if="showButtons && editSnippet">
                <span class="float-right">
                  <span style="cursor: pointer" @click="$emit('deleteSnippet')">
                    <font-awesome-icon :icon="['fas', 'star']" size="1x" />
                  </span>
                  <span
                    class="text-muted save-snippet ml-3"
                    @click="$emit('editSnippet')"
                    ><font-awesome-icon :icon="['far', 'file-alt']" size="1x" />
                  </span>
                </span>
              </template>
              <template v-else-if="showButtons">
                <span class="float-right">
                  <span
                    style="cursor: pointer"
                    @click="$emit('saveSnippetQuick')"
                  >
                    <font-awesome-icon :icon="['far', 'star']" size="1x" />
                  </span>
                  <span
                    class="text-muted save-snippet ml-3"
                    @click="$emit('saveSnippet')"
                    ><font-awesome-icon :icon="['far', 'file-alt']" size="1x" />
                  </span>
                </span>
              </template>
              <!-- <template v-if="showButtons && isExtractDataUngated">
                <b-button
                  v-if="!extractingData"
                  id="extract-data-feature"
                  size="sm"
                  variant="outline-primary"
                  @click="extractingData = true"
                >
                  Extract Data
                  <small>(beta)</small>
                </b-button>
                <b-button
                  v-else
                  id="extract-data-submit"
                  size="sm"
                  variant="outline-primary"
                  :disabled="showExtractDataForm"
                  @click="showExtractDataForm = true"
                >
                  Next
                </b-button>
                <font-awesome-icon
                  v-b-modal.extract-data-help-modal
                  :icon="['far', 'question-circle']"
                  class="mx-2"
                  size="1x"
                />
                <span
                  v-show="extractedData"
                  class="mx-2 align-center saving-info-text"
                >
                  Submitted
                </span>
                <ExtractDataHelpModal />
                <ExtractDataPopover
                  :show="showExtractDataForm"
                  :extractDataHasError="extractDataHasError"
                  :isExtractDataLoading="isExtractDataLoading"
                  @toggle="(show) => (showExtractDataForm = show)"
                  @submit="submitExtractDataRequest"
                  @cancel="onCancelExtractData"
                />
                <NewPopoverExtractData />
              </template> -->
              <!-- <span
                v-if="
                  showEntities && filteredEntities && filteredEntities.length
                "
                class="detected-endpoints"
              >
                Detected Endpoints
              </span> -->
              <!-- <b-button
                v-if="
                  filteredEntities && filteredEntities.length && !showEntities
                "
                class="entity-button"
                size="sm"
                variant="outline-primary"
                @click="showEntities = true"
              >
                Show Entities
              </b-button> -->
              <!--
              <b-button
                v-else-if="filteredEntities && filteredEntities.length"
                class="entity-button"
                size="sm"
                variant="outline-primary"
                @click="showEntities = false"
              >
                Hide Entities
              </b-button>
              -->
            </b-col>
          </b-row>
        </b-container>
      </div>
      <button
        type="button"
        class="close"
        aria-label="Close"
        @click="closeModal"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </template>
    <template #default>
      <div style="height: 60vh">
        <Webviewer
          :isInProject="isInProject"
          :path="`${publicPath}lib`"
          :src="getFilePath"
          :selectedDocPageNum="selectedDocPageNum"
          :entities="
            endpointsTextByDoc && endpointsTextByDoc.length > 0
              ? endpointsTextByDoc
              : []
          "
          :searchTerm="searchTerm"
          :docName="
            selectedDoc._source.doc_title
              ? selectedDoc._source.doc_title.substring(0, 240) + '...'
              : selectedDoc._source.bts_file_name.substring(0, 240) + '...'
          "
          :documentID="selectedDoc.fields && selectedDoc.fields.doc_id[0]"
          :extractingData="extractingData"
          :extractDataAnnotationsMap="extractDataAnnotationsMap"
          :extractDataAnnotationsChanged="
            (newMap) => (extractDataAnnotationsMap = newMap)
          "
          @annotationsSaving="annotationsSaving"
          @annotationsSaved="annotationsSaved"
          @extractAnnotationChanged="extractAnnotationChanged"
        />
      </div>
    </template>
    <template #modal-footer>
      <div
        class="w-100"
        v-if="
          (selectedDoc._source.guidance_topics !== undefined &&
            selectedDoc._source.guidance_topics.length > 0) ||
          (trialInfoByDoc !== undefined && trialInfoByDoc.length > 0) ||
          (trialInfoByProduct !== undefined && trialInfoByProduct.length > 0) ||
          endpointsByDoc.length > 0
        "
      >
        <div
          v-if="
            selectedDoc._source.guidance_topics !== undefined &&
            selectedDoc._source.guidance_topics.length > 1
          "
          class="float-left w-30"
        >
          Topics:
          {{ selectedDoc._source.guidance_topics.join(', ') }}
        </div>
        <div
          v-else-if="
            selectedDoc._source.guidance_topics !== undefined &&
            selectedDoc._source.guidance_topics.length === 1
          "
          class="float-left w-30"
        >
          Topic: {{ selectedDoc._source.guidance_topics[0] }}
        </div>
        <b-button
          id="popover-trials-full-doc"
          class="mb-2"
          size="sm"
          variant="light"
          v-show="trialInfoByDoc.length > 0 || trialInfoByProduct.length > 0"
          >See Associated Clinical Studies</b-button
        >
        <b-popover
          target="popover-trials-full-doc"
          triggers="hover"
          placement="bottom"
          custom-class="w-80"
        >
          <b-tabs content-class="mt-3">
            <b-tab
              v-if="trialInfoByDoc.length > 0"
              title="Identified within Document"
              active
            >
              <b-table :items="trialInfoByDoc" striped hover>
                <template #cell(study_title)="data">
                  <span v-html="data.value"></span>
                </template>
                <!-- <template #table-colgroup="scope">
                                <col
                                  v-for="field in scope.fields"
                                  :key="field.key"
                                  :style="{
                                    width:
                                      field.key === 'foo' ? '120px' : '180px',
                                  }"
                                />
                              </template> -->
              </b-table>
            </b-tab>
            <b-tab
              v-if="trialInfoByProduct.length > 0"
              title="Related to Product"
            >
              <b-table :items="trialInfoByProduct" striped hover>
                <template #cell(study_title)="data">
                  <span v-html="data.value"></span>
                </template>
                <!-- <template #table-colgroup="scope">
                                <col
                                  v-for="field in scope.fields"
                                  :key="field.key"
                                  :style="{
                                    width:
                                      field.key === 'foo' ? '120px' : '180px',
                                  }"
                                />
                              </template> -->
              </b-table>
            </b-tab>
          </b-tabs>
        </b-popover>
        <b-button
          id="popover-endpoints-full-doc"
          class="mx-2 mb-2"
          size="sm"
          variant="light"
          v-show="endpointsByDoc.length > 0"
          >See Associated Endpoints</b-button
        >
        <b-popover
          target="popover-endpoints-full-doc"
          triggers="hover"
          placement="bottom"
          custom-class="w-40"
        >
          <b-table :items="endpointsByDoc" striped hover> </b-table>
        </b-popover>
      </div>
      <div v-else>
        <!-- leave blank to force empty footer -->
      </div>
    </template>
  </b-modal>
</template>

<script>
import Analytics from '@aws-amplify/analytics';
import Webviewer from '@/components/Webviewer.vue';
// import ExtractDataHelpModal from './modals/ExtractDataHelpModal.vue';
// import NewPopoverExtractData from './NewPopoverExtractData.vue';
// import ExtractDataPopover from './ExtractDataPopover.vue';
import { isExtractDataUngated } from '@/constants/gates';
import { mapActions, mapMutations, mapGetters } from 'vuex';
import { getUniqueProductNames } from '@/operators/searchModifiers';
// import { logMessage } from '@/utils/loggerUtils';

export default {
  name: 'PDFJSViewer',
  components: {
    Webviewer,
  },
  props: {
    selectedDoc: Object,
    searchTerm: {
      type: String,
      default: '*',
    },
    selectedDocPageNum: Number,
    endpointsByDoc: Array,
    endpointsTextByDoc: Array,
    trialInfoByDoc: Array,
    trialInfoByProduct: Array,
    editSnippet: Boolean,
    showButtons: {
      type: Boolean,
      default: true,
    },
    isInProject: { type: Boolean, default: true },
  },
  data() {
    return {
      currentPage: this.selectedDocPageNum,
      pageCount: 0,
      proxyUrl: process.env.VUE_APP_PDF_PROXY_URL,
      viewer: './lib/pdfjs-2.9.359-dist/web/viewer.html',
      numPages: 1,
      publicPath: process.env.BASE_URL,
      annotationSaving: false,
      annotationSaved: false,
      extractingData: false,
      extractedData: false,
      showExtractDataForm: false,
      extractDataAnnotationsMap: new Map(),
      showAllTrials: false,
      trialLastIdx: 8,
      showEntities: false,
    };
  },
  computed: {
    ...mapGetters(['isExtractDataLoading', 'extractDataHasError']),
    getFilePath() {
      return encodeURI(
        this.getDocLinkPrefix(this.selectedDoc._source.source_name) +
          this.selectedDoc._source.bts_file_name
      );
    },
    filteredEntities() {
      if (
        this.selectedDoc._source.entities &&
        this.selectedDoc._source.entities.length > 0
      )
        return this.selectedDoc._source.entities;
      else return [];
    },
  },
  watch: {
    isExtractDataLoading(newStatus, oldStatus) {
      if (
        oldStatus === true &&
        newStatus === false &&
        this.extractDataHasError === false
      ) {
        this.extractedData = true;
        this.extractingData = false;
      }
    },
  },
  created() {
    this.showEntities = false;
    this.getUniqueProductNames = getUniqueProductNames;
    this.extractDataAnnotations = '';
    this.isExtractDataUngated = isExtractDataUngated;
    this.showAllTrials = false;
    this.trialLastIdx = 8;
  },
  mounted() {
    //show full doc modal
    this.$bvModal.show('full-doc-modal');
    window.addEventListener('message', this.receivePDFMsg);
    setTimeout(() => {
      this.showEntities = true;
    }, 3000);
  },
  methods: {
    ...mapActions(['requestExtractData']),
    ...mapMutations(['resetExtractData']),
    onCancelExtractData() {
      this.extractingData = false;
    },
    closeModal() {
      this.resetExtractData();
      this.$emit('closePdfViewerModal');
    },
    displayList(list) {
      if (!list || list.length === 0) return '';
      else if (Array.isArray(list)) {
        if (list.length === 1) return list[0];
        else return list.slice(0, -1).join(', ') + ' and ' + list.slice(-1)[0];
      } else return list;
    },
    receivePDFMsg(event) {
      Analytics.record({
        name: `pdf${event.data.target}`,
        attributes: {
          doc: this.selectedDoc._id,
        },
      });
    },
    getDocLinkPrefix(sourceName) {
      return (
        'https://highprioritypipelinev1stack-bucket83908e77-nfink9l696lw.s3.us-east-2.amazonaws.com/' +
        sourceName +
        '/pdfs/'
      );
    },
    annotationsSaving(result) {
      this.annotationSaving = result;
      this.annotationSaved = !result;
    },
    annotationsSaved() {
      this.annotationSaved = true;
    },
    extractAnnotationChanged(annotations) {
      this.extractDataAnnotations = annotations;
    },
    submitExtractDataRequest({ selectedOption, additionalComments }) {
      this.requestExtractData({
        documentID: this.selectedDoc.fields.doc_id[0],
        type: selectedOption,
        additionalComments,
        annotations: this.extractDataAnnotations,
      });
      this.extractDataAnnotationsMap = new Map();
    },
  },
};
</script>

<style scoped>
.full-doc-modal {
  max-width: 100%;
  margin: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100vh;
  display: flex;
  position: fixed;
  z-index: 100000;
}

#download-button {
  margin-left: 20px;
}
.saving-info-text {
  color: #696969;
}

.show-all-trials {
  color: blue;
  font-size: 0.8em;
  cursor: pointer;
}

.entity-button {
  color: #f05825;
  border-color: #f05825;
}

.entity-button:hover {
  color: white;
  border-color: #f05825;
  background-color: #f05825;
}

.detected-endpoints {
  color: #f05825;
}
</style>
